import { DateTimeUtils } from '@servicetitan/datetime-utils';
import { BodyText, BodyTextPropsStrict } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';
import { FC } from 'react';

interface ShortDateTextProps {
    date?: Date;
    className?: string;
    el?: any;
    inline?: boolean;
    size?: BodyTextPropsStrict['size'];
    subdued?: boolean;
}

export const ShortDateText: FC<ShortDateTextProps> = props => {
    const { className, date, el, inline, size, subdued } = props;
    const [dateTimeUtils] = useDependencies(DateTimeUtils);

    return date ? (
        <BodyText size={size} subdued={subdued} inline={inline} el={el} className={className}>
            {`${dateTimeUtils.formatShortMonth(date)} ${date.getDate()}, ${date.getFullYear()}`}
        </BodyText>
    ) : null;
};
